module.exports = __webpack_public_path__ + "static/img/102.7c035b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/102.png
// module id = 488
// module chunks = 3